import type { LostReason, SalesStage } from '../api';
import { LOST_REASON_LABELS } from '../api';
import { SALES_STAGE_META } from '../components/admin/crm/crmLabels';

const STAGE_BODY: Partial<Record<SalesStage, string>> = {
  lead_received: 'Мы приняли вашу заявку. Менеджер свяжется с вами для уточнения деталей.',
  negotiation: 'Обсуждаем конфигурацию и условия. Вопросы — в этот чат.',
  invoice_sent: 'Мы отправили счёт. После оплаты перейдём к замеру и производству.',
  paid: 'Оплата зафиксирована. Далее согласуем замер и сроки.',
  measurement: 'Согласовываем выезд инженера на замер: адрес и удобный интервал.',
  measurement_done: 'Замер выполнен. Уточняем спецификацию по объекту.',
  compose: 'Согласовываем состав заказа и финальную смету.',
  production: 'Заказ в производстве. Сообщим, когда будет готов.',
  ready_to_ship: 'Изделие готово. Согласуем монтаж, доставку или самовывоз.',
  fulfillment: 'Согласовываем выезд на монтаж или доставку.',
  lost: 'Сейчас не можем продолжить этот заказ. Если ситуация изменится — мы на связи.',
};

export function defaultClientMessageForStage(
  orderNumber: string,
  stage: SalesStage,
  opts?: { lostReason?: LostReason; managerComment?: string },
): string {
  const label = SALES_STAGE_META[stage]?.label ?? stage;
  const body = STAGE_BODY[stage] ?? 'Статус заказа обновлён.';
  const lines = [`◈ Заказ ${orderNumber}`, '', label, body];
  if (stage === 'lost' && opts?.lostReason) {
    lines.push('', `Причина: ${LOST_REASON_LABELS[opts.lostReason]}`);
  }
  const comment = opts?.managerComment?.trim();
  if (comment) lines.push('', `Комментарий менеджера: ${comment}`);
  lines.push('', 'Актуальный статус — мини-апп → «Заказы».');
  return lines.join('\n');
}
